import { useApiResultQuery } from 'src/Libs/api'
import { getDownloadSearchResults } from '../api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { DownloadsFilter, DownloadsSearchResult } from '../models/downloads.model'
import { transformFilters } from '../utils'
import { useTypedSelector } from 'src/State/RootReducer'

/**
 * Hook to get all files for a search in the download section
 */
export const useDownloadSearchResults = (filter: DownloadsFilter, searchString?: string): [DownloadsSearchResult[] | undefined, boolean, boolean] => {
  const authFetch = useAuthFetchWithResponse()
  const filterString = transformFilters(filter, searchString)
  const refresh = useTypedSelector(state => state.apiView.refresh)
  const { data, isError, isLoading } = useApiResultQuery({
    queryKey: ['download-files-search', filterString, searchString, refresh],
    fetchFunction: () => getDownloadSearchResults(authFetch, filterString),
    options: {
      enabled: !!searchString && searchString !== '' && searchString.length >= 3,
      staleTime: 0,
    },
  })

  if (isError) {
    return [undefined, isLoading, isError]
  }

  return [data, isLoading, isError]
}
